import { createAction, props } from '@ngrx/store';
import { IProducts } from '../models/products.model';

export const loadPendingProductsFromSomeoneElse = createAction(
  '[PendingProductsFromSomeoneElse] Load PendingProductsFromSomeoneElse',
  props<{ request: string }>()
);

export const loadPendingProductsFromSomeoneElseSuccess = createAction(
  '[PendingProductsFromSomeoneElse] Load PendingProductsFromSomeoneElse Success',
  props<{ response: IProducts[] }>()
);

export const loadPendingProductsFromSomeoneElseFailure = createAction(
  '[PendingProductsFromSomeoneElse] Load PendingProductsFromSomeoneElse Failure',
  props<{ error: Error | any }>()
);
